import React, { Component } from 'react'
import { connect } from 'react-redux'
import NumberFormat from "react-number-format";
import { createPaymentPages } from '../../../state/ducks/payment/types';
import $ from "jquery";
var deger = null;

export class SMSApprovePayFor extends Component {
    saniyeBaslat = () => {
        var saniye = 180;
        deger = window.setInterval(() => {
            saniye--;
            if (saniye >= 1) {
                document.getElementById('saniye').innerHTML = saniye;
                $("#kod").prop("disabled", false);
                $("#dogrulaBtn").css("pointer-events", "all");
                $("#tekrarGonderBtn").css("pointer-events", "none");
            } else {
                window.clearInterval(deger);
                document.getElementById('saniye').innerHTML = "0";
                $("#kod").prop("disabled", true);
                $("#dogrulaBtn").css("pointer-events", "none");
                $("#tekrarGonderBtn").css("pointer-events", "all");
            }
        }, 1000);

    };
    tekrarGonder = () => {
        this.props.sendAgain();
        var saniye = document.getElementById('saniye').innerHTML;
        if (parseInt(saniye) == 0) {
            this.saniyeBaslat();
        }
    }
    save = () => {
        //window.clearInterval(deger);
        this.props.changePage(createPaymentPages.done);
    }
    componentDidMount() {
        this.saniyeBaslat();
    }
    componentWillUnmount() {
        window.clearInterval(deger);
    }
    render() {
        const { sms } = this.props;
        return (
            <>
                <div className="row" style={{ padding: "3%" }}>
                    <div className="col-12">
                        {/* KUTU 1 */}
                        <div className="row no-gutters t-kutu t-yesilCizgi">
                            <div
                                className="col bosluk backtop"
                                style={{
                                    backgroundImage:
                                    'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                                }}
                            >
                                {/* içerikler */}
                                {/* Başlık */}
                                <div className="row no-gutters pb-4">
                                    <div className="col-12 d-flex justify-content-center pb-2">
                                        <i className="t-icon-lock_clock t-icGenelBaslikIcon" />
                                    </div>
                                    <div className="col-12 d-flex justify-content-center pb-3 t-icGenelBaslik">
                                        SMS DOĞRULAMA
                                    </div>
                                    <div className="col-12 text-center t-icYazilar">
                                        Lütfen <strong>{sms.gsm}</strong> nolu cep telefonunuza gönderilen kodu giriniz <br /><br />
                                    </div>
                                </div>
                                {/* Kod */}
                                <div className="row no-gutters my-4 d-flex justify-content-center flex-column align-items-center">
                                    <div className="col-auto pb-1">
                                        <span className="t-icInputTitle pl-3 text-center">SMS Kodu</span>
                                    </div>
                                    <div className="col-auto pb-4">
                                        <div className="t-icInput" style={{ maxWidth: 350 }}>
                                            <div>
                                                <i className="t-icon-phonelink_lock" />
                                            </div>

                                            <NumberFormat
                                                displayType={"input"}
                                                id="kod"
                                                className="email"
                                                placeholder="Lütfen SMS Kodunu Giriniz"
                                                required
                                                value={sms.sms}
                                                maxLength="6"
                                                onChange={e => {
                                                    sms.sms = e.target.value.trim();
                                                    this.setState({ sms: e.target.value.trim() });

                                                }} />
                                            <div />
                                        </div>
                                    </div>
                                    <div
                                        className="col-auto"
                                        style={{ color: "#0c9908", fontWeight: "bold" }}
                                    >
                                        <i className="t-icon-clock pr-2" />
                                        Kalan süre {" "}
                                        <strong id="saniye" style={{ fontSize: "16pt" }}>
                                            180 {" "}
                                        </strong>
                                        sn
                                    </div>
                                    {/* Geri Sayım JS si*/}
                                    {/* Geri Sayım JS si BİTTİ*/}
                                </div>
                                {/* Değiştir*/}
                                <div className="row no-gutters d-flex align-items-center justify-content-center">
                                    <div className="col-auto px-1">
                                        <button className="t-icButonTrunucu" onClick={() => this.props.changePage(createPaymentPages.creditCard)}>
                                            <i className="t-icon-arrow-left2" />
                                            <span>Geri</span>
                                        </button>

                                    </div>
                                    <div className="col-auto px-1">
                                        <button
                                            type="button"
                                            className="t-icButonTrunucu"
                                            id="tekrarGonderBtn"
                                            onClick={this.tekrarGonder}>

                                            <i className="t-icon-loop2 px-2" style={{ fontSize: "14pt" }} />
                                            <span />
                                            <span className="pb-1">Tekrar Gönder</span>
                                        </button>
                                    </div>
                                    <div className="col-auto px-1">
                                        <button
                                            id="dogrulaBtn"
                                            type="button"
                                            className="t-icButtonYesil"
                                            onClick={this.save}
                                        >
                                            <span />
                                            <span className="pb-1">Doğrula</span>
                                            <i
                                                className="t-icon-arrow-right2"
                                                style={{ fontSize: "14pt" }}
                                            />
                                        </button>
                                    </div>
                                </div>
                                {/* STEP LER */}
                                <div className="row no-gutters pt-4 justify-content-center align-items-start">
                                    {/* cizgi*/}
                                    <div className="col-1 t-cizgiBackgroundKenar" />
                                    {/* 1*/}
                                    <div className="col-auto t-icStepPasif">
                                        <div className="ortala">
                                            <div className="yuvarlak">1</div>
                                        </div>
                                        <span>Ödeme Bilgileri</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-auto t-cizgiBackgroundOrta" />
                                    {/* 2*/}
                                    <div className="col-auto t-icStepPasif">
                                        <div className="ortala">
                                            <div className="yuvarlak">2</div>
                                        </div>
                                        <span>Kart Bilgileri</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-auto t-cizgiBackgroundOrta" />
                                    {/* 2*/}
                                    <div className="col-auto t-icStepAktif">
                                        <div className="ortala">
                                            <div className="yuvarlak">3</div>
                                        </div>
                                        <span>Onay</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-1 t-cizgiBackgroundKenar" />
                                </div>
                                {/* içerikler BİTTİ */}
                            </div>
                            <div className="col-auto renk" />
                        </div>
                        {/* KUTU 1 BİTTİ */}
                    </div>
                </div>
                {/* Duyurlar Baslık*/}
                {/* duyrular Bitti*/}
                <div className="row" style={{ height: 30 }} />
            </>

        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(SMSApprovePayFor)
